<div class="group flex items-center gap-2">
  <ng-container #fieldComponent />
  <label class="cursor-pointer" [for]="field.id">{{
    `${field.props?.label}` | translate
  }}</label>
</div>
